import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';
import { WIDGET_API } from 'utils/constants';

import type { PayHubWidgetContractsSubmitPaymentResponse, PayHubWidgetContractsSubmitPayoutResponse } from '../models';

export interface DisplayFormRequest {
  payGroupId: number;
  requestBody: FormData;
  signal?: AbortSignal;
}

export type DisplayFormResponse =
  PayHubWidgetContractsSubmitPaymentResponse | PayHubWidgetContractsSubmitPayoutResponse;

export const displayFormAPI = createApi({
  reducerPath: 'displayFormAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints(builder) {
    return {
      confirmDisplayForm: builder.mutation<DisplayFormResponse, DisplayFormRequest>({
        query: ({ payGroupId, requestBody }) => ({
          url: `payments/groups/${payGroupId}/confirm`,
          method: 'POST',
          body: requestBody,
        }),
        transformResponse: (response: DisplayFormResponse): DisplayFormResponse => response,
      }),
      cancelDisplayForm: builder.mutation<DisplayFormResponse, DisplayFormRequest>({
        query: ({ payGroupId, requestBody }) => ({
          url: `payments/groups/${payGroupId}/cancel`,
          method: 'POST',
          body: requestBody,
        }),
        transformResponse: (response: DisplayFormResponse): DisplayFormResponse => response,
      }),
    };
  },
});

export const { useConfirmDisplayFormMutation, useCancelDisplayFormMutation } = displayFormAPI;

export default displayFormAPI.reducer;
